"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactive = void 0;
const mobx_1 = require("mobx");
/**
 * Свойство класса, в котором хранится количество раз, которое к этому классу
 * был применён декоратор `reactive`.
 */
const STACK_DEPTH = Symbol('STACK_DEPTH');
/**
 * Свойство экземпляра класса, в котором хранится уровень текущего вызова
 * конструктора `ReactiveStore` в стеке вызовов контрукторов.
 */
const STACK_INDEX = Symbol('STACK_INDEX');
/**
 * Возвращает класс, унаследованный от указанного, который запускает механизмы
 * observable, action и computed для его свойств и методов.
 *
 * @param target Класс хранилища.
 */
exports.reactive = (target) => {
    var _a;
    /**
     * Запускает механизмы mobx для членов родительского класса.
     */
    class ReactiveStore extends target {
        /**
         * Создаёт экземпляр хранилища.
         * @param args Аргументы.
         */
        constructor(...args) {
            var _a;
            super(...args);
            // @ts-ignore
            const depth = this.constructor[STACK_DEPTH];
            // @ts-ignore
            let index = (_a = this[STACK_INDEX]) !== null && _a !== void 0 ? _a : 0;
            index += 1;
            // @ts-ignore
            this[STACK_INDEX] = index;
            if (index === depth) {
                mobx_1.makeObservable(this);
            }
        }
    }
    // @ts-ignore
    let depth = (_a = ReactiveStore[STACK_DEPTH]) !== null && _a !== void 0 ? _a : 0;
    depth += 1;
    // @ts-ignore
    ReactiveStore[STACK_DEPTH] = depth;
    return ReactiveStore;
};
